import React from "react"
import { withPlayButton } from "core/utils"

export const EmailVideo = ({ node, attributes }) => {
  const data = node.data.toJS()

  const {
    href,
    width = 480,
    alignment = "center",
    accentColor = "#1677BE",
    playButtonColor = "#FFFFFF"
  } = data

  let margin = "0 auto"
  switch (alignment) {
    case "right":
      margin = "0 0 0 auto"
      break
    case "left":
      margin = "0 auto 0 0"
      break
  }

  const clickHandler = e => {
    e.preventDefault()
    return false
  }

  return (
    <a href={href} target="_blank" rel="noreferrer" onClick={clickHandler}>
      <img
        src={withPlayButton({
          thumbnailof: href,
          accent: accentColor,
          play: playButtonColor,
          width: width,
          height: width / (16 / 9),
          fit: "contain"
        })}
        alt=""
        width={width}
        height={width / (16 / 9)}
        style={{ borderRadius: 4, margin }}
        {...attributes}
      />
    </a>
  )
}

export default EmailVideo
